import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { DE } from "./locales/de";
import { FR } from "./locales/fr";
import { EN } from "./locales/en";
import { IT } from "./locales/it";
import { ES } from "./locales/es";
import { NL } from "./locales/nl";

const resources = {
  de: DE,
  fr: FR,
  en: EN,
  it: IT,
  es: ES,
  nl: NL,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: true,
    detection: {
      order: ["navigator"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
